// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const { PI, log, log10, cos, sin, hypot } = Math;

export function logx(x: number, a: number): number {
	return log(a) / log(x);
}
